import {ICustomerGroupPrices} from "../pages/[productSlug]";

export type CustomerGroupPrice = {
    id: number;
    product_id: number;
    customer_group_id: string | null;
    qty: string;
    value_type: string;
    value: string;
    updated_at: string;
    created_at: string;
};

type Product = {
    id: number;
    flats: {price: number}[];
};


function filterCustomerGroupPrices(
    customerGroupPrices: ICustomerGroupPrices[] | undefined,
    customerGroupId: string,
    product: Product,
    innerPage: boolean
): ICustomerGroupPrices[] | undefined {
    return customerGroupPrices?.filter((element) => {
        if (
            (element.customer_group_id === null || customerGroupId === element.customer_group_id) &&
            element.product_id === product.id
        ) {
            if (innerPage || element.qty === "1") {
                return true;
            }
        }
        return false;
    });
}
function applyDiscountToCustomerGroupPrices(
    customerGroupPrices: CustomerGroupPrice[] | undefined,
    product: Product
): CustomerGroupPrice[] | undefined {
    return customerGroupPrices?.map((elem) => {
        if (elem.value_type === "discount") {
            const discountValue = 100 - +elem.value;
            const priceGroupVal = product.flats?.[0].price * discountValue / 100;
            return { ...elem, value: priceGroupVal.toString() };
        }
        return elem;
    });
}

function getMinimumValues(
    customerGroupPrices: CustomerGroupPrice[] | undefined
): Map<string, string> {
    const qtyToMinValue = new Map<string, string>();

    customerGroupPrices?.forEach((item) => {
        const qty = item.qty;
        const value = item.value;

        if (!qtyToMinValue.has(qty) || +value < +qtyToMinValue.get(qty)!) {
            qtyToMinValue.set(qty, value);
        }
    });

    return qtyToMinValue;
}
function filterByMinimumValues(
    customerGroupPrices: CustomerGroupPrice[] | undefined,
    qtyToMinValue: Map<string, string>,
    currRate?: string
): CustomerGroupPrice[] | undefined {
    const filteredPrices = customerGroupPrices?.filter(
        (item) => item.value === qtyToMinValue.get(item.qty)
    );

    if (!filteredPrices) {
        return undefined;
    }
    const sortedPrices = filteredPrices.sort((a, b) => +a.qty - +b.qty);
    const addCurrencyInPrices = sortedPrices.map((customerGroup: any) => {
        if (currRate) {
            const currencyToggle = parseFloat(customerGroup.value) * +currRate
            return {
                ...customerGroup,
                value: String(currencyToggle)
            }
        }
        return customerGroup
    })
    let minValue: string | undefined = addCurrencyInPrices[0]?.value;

    return addCurrencyInPrices?.map((item) => {
        if (minValue) {
            item.value = String(Math.min(+item.value, +minValue));
            minValue = item.value;
        }
        return item;
    });
}

export const updatedProductGroupToggle = (
    customerGroupPrices: ICustomerGroupPrices[] | undefined,
    customerGroupId: string,
    product: Product,
    innerPage: boolean,
    currRate?: string
): any | CustomerGroupPrice[] => {
    const filteredCustomerGroupPrices = filterCustomerGroupPrices(customerGroupPrices, customerGroupId, product, innerPage);
    const updatedCustomerGroupPrices = applyDiscountToCustomerGroupPrices(filteredCustomerGroupPrices, product);
    if (innerPage) {
        const qtyToMinValue = getMinimumValues(updatedCustomerGroupPrices);
        return filterByMinimumValues(updatedCustomerGroupPrices, qtyToMinValue, currRate)
    } else {
        const findGroup = updatedCustomerGroupPrices
            ?.reduce((min, item) =>
                    (Number(item.value) < Number(min.value) ? item : min),
                updatedCustomerGroupPrices[0]
            );
        if (customerGroupPrices && findGroup) {
            return {
                ...product,
                flats: [{
                    ...product.flats?.[0],
                    special_price: findGroup.value
                }]
            }
        }
        return product
    }
}
